import React, { useEffect, useState } from 'react';

const EMOJIS = ['🌿', '⭐', '🎉', '🌟', '✨', '🍀', '🎈', '💚'];
const COLORS = ['#3D9A6A', '#52C289', '#FF7043', '#FFB300', '#EDF7F1'];

export default function Confettis({ trigger, onDone }) {
  const [particles, setParticles] = useState([]);

  useEffect(() => {
    if (!trigger) return;
    const newParticles = Array.from({ length: 20 }, (_, i) => ({
      id: i,
      x: Math.random() * 100,
      emoji: EMOJIS[Math.floor(Math.random() * EMOJIS.length)],
      color: COLORS[Math.floor(Math.random() * COLORS.length)],
      size: 0.8 + Math.random() * 1.2,
      duration: 0.8 + Math.random() * 0.8,
      delay: Math.random() * 0.4,
    }));
    setParticles(newParticles);
    const timer = setTimeout(() => {
      setParticles([]);
      if (onDone) onDone();
    }, 1500);
    return () => clearTimeout(timer);
  }, [trigger]);

  if (particles.length === 0) return null;

  return (
    <div style={{ position: 'fixed', inset: 0, pointerEvents: 'none', zIndex: 9999, overflow: 'hidden' }}>
      {particles.map(p => (
        <div key={p.id} style={{
          position: 'absolute',
          left: `${p.x}%`,
          bottom: '10%',
          fontSize: `${p.size}rem`,
          animation: `confetti ${p.duration}s ease-out ${p.delay}s forwards`,
          opacity: 0,
        }}>
          {p.emoji}
        </div>
      ))}
      <style>{`
        @keyframes confetti {
          0% { transform: translateY(0) rotate(0deg) scale(1); opacity: 1; }
          100% { transform: translateY(-80vh) rotate(720deg) scale(0.5); opacity: 0; }
        }
      `}</style>
    </div>
  );
}